<template>
  <!-- 北师大单独设置字体颜色 -->
  <div :id="$store.state.id == 27 ? 'main-27' : 'main'" :style="$store.state.id == 8 ? 'color: #BE261F;' : ''">
    <!-- <div class="topStatisticsButton" @click="topSelect">
      <div :class="select === 0 ? 'select' : ''"
         :style="{'background-image':  select === 0 ?
         'url(' + `${$store.state.data.baseUrl}/${$store.state.id == 27 ? 'statistics_title1_select' : 'statistics_title_select'}.png` + ')' : 'url(' + `${$store.state.data.baseUrl}/${$store.state.id == 27 ? 'statistics_title2' : 'statistics_title'}.png` + ')'}"><p>全国统计</p></div>
      <div :class="['second', select === 1 ? 'select' : '']"
         :style="{'background-image':  select === 1 ?
         'url(' + `${$store.state.data.baseUrl}/${$store.state.id == 27 ? 'statistics_title2_select' : 'statistics_title_select'}.png` + ')' : 'url(' + `${$store.state.data.baseUrl}/${$store.state.id == 27 ? 'statistics_title1' : 'statistics_title'}.png` + ')'}"><p>全球统计</p></div>
    </div> -->
    <!-- <div v-if="$store.state.id == 27" class="top-line1"></div> -->
    <!-- <div v-if="$store.state.id == 27" class="top-line2"></div> -->
    <img class="title-bg" src="../image/blg-phb-nav-ph.png" alt="">
    <!-- <div class="main-bg" :style="{'background-image':  'url(' + `${$store.state.data.baseUrl}/statistics_bg.png`  + ')'}"></div> -->
    <div class="cell cell-title" :class="$store.state.id == 27 ? 'cell-27' : ''">
      <p class="city">{{ select === 0 ? (($store.state.data.type == 8 || $store.state.id == 27) ? '省市' : '城市') : '国家' }}</p>
      <!-- 北师大单独设置统计样式 -->
      <p :class="$store.state.data.type == 8 ? '' : 'num'">{{ $store.state.id == 27 ? '点赞数 ' : '人数' }}</p>
      <p v-if="$store.state.data.type == 8">排名</p>
    </div>
    <ul class="infinite-list" v-infinite-scroll="load" style="overflow:auto">
      <li v-for="i,index in statisticsData"
         :key="i.name"
         class="infinite-list-item">
        <div class="cell" :class="$store.state.id == 27 ? 'cell-27' : ''">
          <p class="city">{{ i.name }}</p>
          <!-- 北师大单独设置人数单位 -->
          <p :class="$store.state.data.type == 8 ? '' : 'num'">{{ i.value }}{{ $store.state.data.type == 8 ? '人' : '' }}</p>
          <p v-if="$store.state.data.type == 8 ">{{ index + 1 }}</p>
        </div>
      </li>
    </ul>
    <div v-if="$store.state.id == 27" class="tips">（按照点赞数排列）</div>
  </div>
</template>

<script>

import { statistics, rank } from '@/services/data';

export default {
  data() {
    return {
      select: 0, // 选中位置 0 全国 1 全球
      page: 1, // 数据分页
      loading: false, // 正在加载
      statisticsData: [], // 统计数据
    };
  },
  created() {
    this.getStatistics();
  },
  methods: {
    load() {
      // if (this.loading) return;
      // this.getStatistics();
    },

    topSelect(e) {
      if (this.loading) return;
      const innerText = e.target.innerText.replace(/[\r\n]/g, '');
      if (innerText === '全国统计') {
        if (this.select === 0) return;
        this.select = 0;
      }
      if (innerText === '全球统计') {
        if (this.select === 1) return;
        this.select = 1;
      }
      this.page = 1;
      this.statisticsData = [];
      this.getStatistics();
    },

    // 获取统计数据
    async getStatistics() {
      this.loading = true;
      // eslint-disable-next-line max-len
      if (this.$store.state.id == 27) {
        const { data: { data = {} } } = await rank();
        if (data.length > 0) {
          this.statisticsData = this.statisticsData.concat(data);
          console.log('统计数据： ', data, this.statisticsData);
        }
        this.loading = false;
      } else {
        const { data: { data: { data = {} } } } = await statistics(this.select === 0 ? 1 : 2, this.page, 100000);
        if (data.length > 0) {
          this.page += 1;
          this.statisticsData = this.statisticsData.concat(data);
          console.log('统计数据： ', data, this.statisticsData);
        }
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="less" scoped>
// @scale: (100vw / 750);
#main {
  position: relative;
  margin-top: 108px;
  width: 675px;
  margin-left: calc((100vw - 675px) / 2);
  height: 772px;
  background-size: cover;
  color: #FFFFFF;
  .main-bg {
    position: absolute;
    z-index: -1;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-size: cover;
  }
  .topStatisticsButton {
    position: absolute;
    z-index: -1;
    height: 63px;
    top: -55px;
    left: 17px;
    display: flex;
    div {
      position: absolute;
      z-index: 1;
      bottom: 0;
      background-size: 100% 100%;
      width: 222px;
      height: 53px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 28px;
      font-family: HuXiaoBo-NanShen;
      font-weight: 400;
      color: #FFFFFF;
    }
    .second {
      left: 210px;
    }
    .select {
      z-index: 2;
      // width: 226px;
      // height: 63px;
      // font-size: 32px;
    }
  }
  .infinite-list {
    z-index: 1;
    widows: 100%;
    height: calc(100% - 190px);
  }
  .cell {
    width: 100%;
    height: 90px;
    display: flex;
    align-items: center;
    p {
      display: flex;
      justify-content: center;
      align-items: center;
      width: calc(50% - 70px);
      font-size: 32px;
      font-family: HuXiaoBo-NanShen;
      font-weight: 400;
    }
    .num {
      width: calc(50% + 70px);
    }
  }
  .cell-27 {
    p {
      width: calc(50%);
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 30px;
      color: #4E0605;
      text-align: center;
      font-style: normal;
      text-transform: none;
    }
    .num {
      width: calc(50%);
    }
  }
  .cell-title {
    padding-top: 50px;
  }
}

#main-27 {
  position: absolute;
  top: 80px;
  margin-left: calc((100vw - 640px) / 2);
  background-size: cover;
  width: 640px;
  // height: 896px;
  // height: calc(100vh - 80px - 286px);
  margin-top: calc((100vh - 80px - 286px - 968px) / 2);
  height: 968px;
  background: #FFFDF9;
  border-radius: 20px;
  z-index: 1;

  .top-line1 {
    position: absolute;
    top: 0;
    left: 0;
    width: 320px;
    height: 17px;
    background: #FFBA54;
    border-radius: 0px 9px 9px 17px;
  }
  .top-line2 {
    position: absolute;
    top: 0;
    left: 320px;
    width: 320px;
    height: 17px;
    background: #FFBA54;
    border-radius: 0px 9px 9px 17px;
  }
  .title-bg {
    width: 640px;
    height: 72px;
  }
  .main-bg {
    position: absolute;
    z-index: -1;
    background-size: cover;

    bottom: 0;
    left: 90px;
    width: 460px;
    height: 601px;
  }
  .topStatisticsButton {
    position: absolute;
    z-index: -1;
    height: 72px;
    top: -72px;
    left: 0px;
    display: flex;
    div {
      position: absolute;
      z-index: 1;
      bottom: 0;
      background-size: 100% 100%;
      width: 196px;
      height: 72px;
    }
    .second {
      left: 196px;
    }
    .select {
      z-index: 2;
    }
    p {
      opacity: 0;
    }
  }
  .infinite-list {
    z-index: 1;
    widows: 100%;
    height: calc(100% - 72px - 90px - 29px - 28px - 29px);
    padding-bottom: calc(29px + 28px);
    box-sizing: border-box;
  }
  .cell {
    width: 100%;
    height: 90px;
    display: flex;
    align-items: center;
    p {
      display: flex;
      justify-content: center;
      align-items: center;
      width: calc(50%);
      font-size: 32px;
      font-family: HuXiaoBo-NanShen;
      font-weight: 400;
    }
    .num {
      width: calc(50%);
    }
  }
  .cell-27 {
    p {
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 30px;
      color: #4E0605;
      text-align: center;
      font-style: normal;
      text-transform: none;
    }
  }
  .cell-title {
    // padding-top: 50px;
    padding-top: 0;
  }
  .tips {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    bottom: 29px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 28px;
    color: #DDA563;
    text-align: center;
    font-style: normal;
    text-transform: none;
  }
}
</style>
